import { useEffect, useState } from "react";
import { ObraSocialList } from "../../../../models/obra-social-list";
import { obrasocialServices } from "../../../../services/obra-social.services";
import "./obras-sociales.scss";

export default function ObrasSociales() {
  const [data, setData] = useState<ObraSocialList[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [filtro, setFiltro] = useState("");

  useEffect(() => {
    obrasocialServices
      .getActiveList()
      .then((res) => setData(res.data))
      .catch(() =>
        setError("No se pudo cargar el listado. Intente nuevamente.")
      )
      .finally(() => setLoading(false));
  }, []);

  const filtradas = data.filter(
    (os) =>
      os.nombre.trim().toUpperCase() !== "VALOR ETICO MINIMO" &&
      `${os.nombre} ${os.siglas}`.toLowerCase().includes(filtro.toLowerCase())
  );

  return (
    <section id="obras-sociales" className="section os-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Obras Sociales</h2>
        <p>
          Listado de obras sociales y entidades de medicina prepaga con convenio
          vigente con el Colegio de Fonoaudiólogos de La Pampa.
        </p>
      </div>

      <div className="container fade-up">
        {/* ── Buscador ── */}
        <div className="os-search">
          <i className="bi bi-search os-search__icon"></i>
          <input
            type="text"
            className="os-search__input"
            placeholder="Buscar por nombre"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
          {filtro && (
            <button className="os-search__clear" onClick={() => setFiltro("")}>
              <i className="bi bi-x-lg"></i>
            </button>
          )}
        </div>

        {/* ── Estado: cargando ── */}
        {loading && (
          <div className="os-state">
            <div className="os-spinner">
              <div className="os-spinner__ring"></div>
            </div>
            <p>Cargando obras sociales...</p>
          </div>
        )}

        {/* ── Estado: error ── */}
        {error && (
          <div className="os-state os-state--error">
            <i className="bi bi-exclamation-triangle-fill"></i>
            <p>{error}</p>
          </div>
        )}

        {/* ── Estado: sin resultados ── */}
        {!loading && !error && filtradas.length === 0 && (
          <div className="os-state">
            <i className="bi bi-search"></i>
            <p>
              No se encontraron resultados para <strong>"{filtro}"</strong>.
            </p>
          </div>
        )}

        {/* ── Tabla ── */}
        {!loading && !error && filtradas.length > 0 && (
          <>
            <p className="os-count">
              <strong>{filtradas.length}</strong> obra
              {filtradas.length !== 1 ? "s" : ""} social
              {filtradas.length !== 1 ? "es" : ""} con convenio vigente
            </p>
            <div className="row g-3">
              {filtradas.map((os) => (
                <div className="col-md-6 col-lg-4" key={os.id}>
                  <div className="os-card">
                    <div className="os-card__icon">
                      <i className="bi bi-hospital"></i>
                    </div>
                    <div className="os-card__body">
                      <p className="os-card__nombre">{os.nombre}</p>
                      {(os.localidad || os.provincia) && (
                        <span className="os-card__lugar">
                          <i className="bi bi-geo-alt"></i>
                          {[os.localidad, os.provincia]
                            .filter(Boolean)
                            .join(", ")}
                        </span>
                      )}
                      {os.domicilio && (
                        <span className="os-card__dir">
                          <i className="bi bi-building"></i>
                          {os.domicilio}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
